import { ModuleListExtraColumnsConfig } from '../interfaces/shared/module-list-extra-columns-config.interface';

export const LIST_EXTRAS_MAX_COLUMNS = 5;

function sanitizeColumnIds(
  columnIds: unknown,
  config: ModuleListExtraColumnsConfig,
): string[] {
  if (!Array.isArray(columnIds)) {
    return [];
  }

  const validIds = new Set(config.columns.map((column) => column.id));
  const seen = new Set<string>();
  const result: string[] = [];

  for (const id of columnIds) {
    if (typeof id !== 'string' || !validIds.has(id) || seen.has(id)) {
      continue;
    }
    seen.add(id);
    result.push(id);
    if (result.length >= LIST_EXTRAS_MAX_COLUMNS) {
      break;
    }
  }

  return result;
}

export function defaultVisibleColumnIds(
  config: ModuleListExtraColumnsConfig,
): string[] {
  const validIds = new Set(config.columns.map((column) => column.id));
  return config.defaultVisibleColumnIds
    .filter((id) => validIds.has(id))
    .slice(0, LIST_EXTRAS_MAX_COLUMNS);
}

export function normalizeVisibleColumnIds(
  stored: unknown,
  config: ModuleListExtraColumnsConfig,
): string[] {
  if (!Array.isArray(stored)) {
    return defaultVisibleColumnIds(config);
  }

  if (stored.length === 0) {
    return [];
  }

  const sanitized = sanitizeColumnIds(stored, config);
  return sanitized.length > 0 ? sanitized : defaultVisibleColumnIds(config);
}

export function sanitizeDraftColumnIds(
  columnIds: string[],
  config: ModuleListExtraColumnsConfig,
): string[] {
  return sanitizeColumnIds(columnIds, config);
}

export function resolveListExtrasColumnCount(
  config: ModuleListExtraColumnsConfig | undefined,
  storedColumnIds: string[] | undefined,
): number {
  if (config == null) {
    return 0;
  }

  if (storedColumnIds === undefined) {
    return defaultVisibleColumnIds(config).length;
  }

  return normalizeVisibleColumnIds(storedColumnIds, config).length;
}
